<template>
  <div class="business">
    <menuBox :step="2"></menuBox>
    <div class="about-1">
      <div class="">เกี่ยวกับเรา</div>
      <p>มุ่งมั่นที่จะเพิ่มประสิทธิภาพการบริการลูกค้าและประสบการณ์ผู้ใช้อย่างต่อเนื่อง เพื่อเพิ่มความพึงพอใจและความไว้วางใจของผู้ใช้</p>
    </div>
    <div class="about-2">
      <div class="title">วิธีการเลือกผลิตภัณฑ์สินเชื่อที่เหมาะสม</div>
      <!-- <div class="sbtitle">เข้าใจความต้องการ</div> -->
      <div class="list-box">
        <div class="item">
          <img src="../assets/about-2.png" alt="">
          <div>เข้าใจความต้องการ</div>
          <p>ชี้แจงความต้องการทางการเงินและความสามารถในการชำระหนี้ของคุณ และเลือกจำนวนเงินกู้และระยะเวลาที่เหมาะสมกับคุณ</p>
        </div>
        <div class="item">
          <img src="../assets/about-3.png" alt="">
          <div>เปรียบเทียบอัตราดอกเบี้ย</div>
          <p>ตรวจสอบอัตราดอกเบี้ยและค่าธรรมเนียมของผลิตภัณฑ์สินเชื่อต่างๆ และเลือกรายการที่มีอัตราดอกเบี้ยต่ำและค่าธรรมเนียมที่โปร่งใส</p>
        </div>
        <div class="item">
          <img src="../assets/about-4.png" alt="">
          <div>ตรวจสอบข้อกำหนด</div>
          <p>อ่านข้อกำหนดและเงื่อนไขสินเชื่ออย่างละเอียดเพื่อให้แน่ใจว่าคุณเข้าใจค่าธรรมเนียมและการชำระคืนข้อกำหนดทั้งหมดเพื่อหลีกเลี่ยงค่าใช้จ่ายแอบแฝงที่ไม่จำเป็น</p>
        </div>
      </div>
    </div>

    <div class="about-3">
      <div class="title">วิธีใช้แฟลชเงิน</div>
      <div class="sbtitle">กรุณาดาวน์โหลดแฟลชเงิน, แฟลชเงินจากช่องทางที่เป็นทางการและเป็นทางการเพื่อช่วยให้ผู้ใช้รับเงินทุน</div>
      <div class="list-box">
        <div class="item">
          <img src="../assets/about-5.png" alt="">
          <div class="text-box">
            <div>ดาวน์โหลดแฟลชเงิน</div>
            <p>ดาวน์โหลดแฟลชเงินจาก Google Play Store</p>
          </div>
        </div>
        <div class="item">
          <img src="../assets/about-5.png" alt="">
          <div class="text-box">
            <div>กรอกข้อมูลการสมัคร</div>
            <p>กรอกข้อมูลส่วนตัวในการขอสินเชื่อ</p>
          </div>
        </div>
        <div class="item">
          <img src="../assets/about-5.png" alt="">
          <div class="text-box">
            <div>การอนุมัติโควต้า</div>
            <p>เลือกจำนวนเงินกู้และรอการอนุมัติ</p>
          </div>
        </div>
        <div class="item">
          <img src="../assets/about-5.png" alt="">
          <div class="text-box">
            <div>รอผลสรุปการอนุมัติ</div>
            <p>รอผลการอนุมัติ</p>
          </div>
        </div>
        <div class="item">
          <img src="../assets/about-5.png" alt="">
          <div class="text-box">
            <div>รายการเงินกู้</div>
            <p>เมื่ออนุมัติสินเชื่อแล้ว เงินจะโอนเข้าบัญชีธนาคารของคุณ</p>
          </div>
        </div>

      </div>
    </div>

    <div class="about-4">
      <div class="title">ปรับปรุงความรู้ทางการเงิน</div>
      <div class="sbtitle">การปรับปรุงความรู้ทางการเงินสามารถทำได้โดยการเรียนรู้ความรู้พื้นฐาน ฝึกฝนการจัดการทางการเงิน และให้ความสนใจกับการเปลี่ยนแปลงของตลาด</div>
      <div class="list-box">
        <div class="item">
          <img src="../assets/about-10.png" alt="">
          <div>เรียนรู้พื้นฐาน</div>
          <p>อ่านหนังสือทางการเงิน ดูหลักสูตรออนไลน์ และเข้าร่วมสัมมนาเพื่อเรียนรู้เกี่ยวกับแนวคิดทางการเงินขั้นพื้นฐาน เช่น การจัดการงบประมาณ กลยุทธ์การลงทุน และการประเมินความเสี่ยง</p>
        </div>
        <div class="item">
          <img src="../assets/about-11.png" alt="">
          <div>การจัดการทางการเงินเชิงปฏิบัติ</div>
          <p>ใช้ความรู้ที่คุณได้เรียนรู้เพื่อพัฒนาแผนงบประมาณส่วนบุคคล ลงทุนเพียงเล็กน้อย และทบทวนและปรับสถานการณ์ทางการเงินของคุณเป็นประจำเพื่อรับประสบการณ์เชิงปฏิบัติ</p>
        </div>
        <div class="item">
          <img src="../assets/about-12.png" alt="">
          <div>ให้ความสนใจกับการเปลี่ยนแปลงของตลาด</div>
          <p>อ่านข่าวการเงินและรายงานการวิเคราะห์ตลาดเป็นประจำ ให้ความสนใจกับแนวโน้มทางเศรษฐกิจและการเปลี่ยนแปลงนโยบาย และปรับปรุงความอ่อนไหวและทักษะการวิเคราะห์ของคุณในตลาดการเงิน</p>
        </div>
      </div>
    </div>

    <footerBox></footerBox>
  </div>
</template>
<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
export default {
  name: "App",
  components: {
    menuBox,
    footerBox,
  },
  data() {
    return {};
  },
  mounted() { },
  methods: {
    aboutUs() {
      this.$router.push({ path: "aboutUs" });
    },
  },
};
</script>
<style lang="less" scoped>
.title {
  font-weight: bold;
  font-size: 52px;
  color: #333333;
  text-align: center;
}

.sbtitle {
  font-weight: 400;
  font-size: 20px;
  color: #888888;
  margin-top: 26px;
  text-align: center;
}

.about-1 {
  background: url(../assets/about-1.png);
  background-size: 100% 100%;
  height: 600px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  div {
    font-weight: 900;
    font-size: 100px;
    color: #6233A7;
    margin-top: 79px;
  }

  p {
    font-weight: bold;
    font-size: 42px;
    color: #333333;
    padding: 0px 360px;
  }
}

.about-2 {
  padding: 150px 360px;

  .list-box {
    margin-top: 80px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .item {
      img {
        width: 100px;
      }

      div {
        margin-top: 50px;
        font-weight: normal;
        font-size: 24px;
        color: #0E0729;
      }

      p {
        font-weight: 400;
        font-size: 20px;
        color: #827F8D;
        margin-top: 12px;
      }

      span {
        font-weight: bold;
        font-size: 16px;
        color: #6233A7;
        margin-top: 10px;
      }
    }
  }
}

.about-3 {
  padding: 0px 300px;

  .list-box {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;

    .item {
      width: 343px;
      height: 74px;
      background: #FFFFFF;
      border-radius: 20px 20px 20px 20px;
      border: 1px solid #D4DBE3;
      padding: 16px;
      display: flex;
      margin: 0px 20px;
      margin-top: 48px;

      img {
        width: 72px;
      }

      .text-box {
        margin-left: 24px;

        div {
          font-weight: bold;
          font-size: 20px;
          color: #101566;
        }

        p {
          font-weight: 500;
          font-size: 14px;
          color: #627A95;
          margin-top: 8px;
        }
      }
    }
  }
}

.about-4 {
  padding: 150px 360px;

  .list-box {
    margin-top: 80px;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;

    .item {
      width: 385px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      img {
        width: 385px;
      }

      div {
        font-weight: 600;
        font-size: 24px;
        color: #37393F;
        margin-top: 30px;
      }

      p {
        font-weight: 400;
        font-size: 18px;
        color: #7D7D7D;
        margin-top: 30px;
      }
    }
  }
}
</style>
